import script from "./AdministratorProjectIndexes.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectIndexes.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectIndexes.vue?vue&type=style&index=0&id=962c270c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-962c270c"]])

export default __exports__